angular.module('unergie.main')
.controller('organizationsCtrl', ($scope, $state, $uibModal, AlertManager, NgTableParams, DataAccessRefOrganization, DataAccess, FilterMapping, BoFeaturesService, ModalService, CommonRegex,
    DataAccessOffers, TableGeneratorService, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    $scope.booleanFilter = [{ id: 'true', title: 'Oui' }, { id: 'false', title: 'Non' }]
    $scope.organizationTypes = FilterMapping.organizationTypes

    $scope.canCloseAgreement = BoFeaturesService.isFeatureOn('canCloseAgreement')
    $scope.handlesBillDistributorReadings = BoFeaturesService.isFeatureOn('handlesBillDistributorReadings')
    $scope.handlesFacturX = BoFeaturesService.isFeatureOn('handlesFacturX')
    $scope.handleIsNonProfiled = BoFeaturesService.isFeatureOn('handleIsNonProfiled')
    const canUpdateBillDistributorReadings = BoFeaturesService.isFeatureOn('canUpdateBillDistributorReadings')
    const handlesB2GB2B = BoFeaturesService.isFeatureOn('handlesB2GB2B')

    const PAYMENT_MODES = ['TRANSFER', 'SEPA', 'FACTORING']
    const SEGMENTS = {
        ELEC: ['C1', 'C2', 'C3', 'C4', 'C5'],
        GAS: ['T1', 'T2', 'T3', 'T4'],
    }

    $scope.organizations = {
        show: {},
        refreshing: false,
        columns: {
            id: { label: 'Id', mode: 'search_wildcard', mandatory: true },
            type: { label: 'Type', mode: 'search_wildcard' },
            backoffice_url: { label: 'Url backoffice', mode: 'search_wildcard' },
            handle_service_orders: { label: 'Gestion ordres de service', mode: 'search_strict' },
            service_order_conf: { label: 'Conf SO', mode: 'hidden' },
            agreements: { label: 'Marchés', mode: 'filter_only' },
            backoffice_menus: { label: 'Accès menus', mode: 'hidden' },
            contact_infos: { label: 'Informations de contact', mode: 'hidden' },
            default_provider_offers: { label: 'Offres par défaut', mode: 'hidden' },
        },
    }

    if (!handlesB2GB2B) {
        delete $scope.organizations.columns.handle_service_orders
        delete $scope.organizations.columns.service_order_conf
        delete $scope.organizations.columns.agreements
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.organizations, 'organizations', 'agreements', null, { orderBy: 'id' })

    $scope.refresh()

    $scope.delete = (organization) =>
        DataAccessRefOrganization.delOrganization({ id: organization.id }).$promise.then((data) => $scope.refresh()).catch(ErrorCatcher)


    const organizationTemplate = {
        id: null,
        backoffice_url: null,
        type: null,
    }

    $scope.organizationFields = {
        id: {
            label: `Nom (lettres/chiffres/'-', sans espace et en minuscule de préférence)`,
            required: true,
            type: 'text',
            pattern: /^[A-Za-z0-9]+[A-Za-z0-9-]*[A-Za-z0-9]+$/,
        },
        type: {
            label: 'Type',
            required: true,
            type: 'select',
            enum: _.map(_.filter($scope.organizationTypes, (ot) => !['PROVIDER', 'SUPERVISOR'].includes(ot.id)), (ot) => ({ label: ot.title, value: ot.id })),
        },
        backoffice_url: {
            label: 'Url Backoffice (optionnel)',
            type: 'text',
        },
    }

    $scope.updateOrganizationFields = angular.copy($scope.organizationFields)
    $scope.updateOrganizationFields.id.hidden = true

    $scope.resetOrganizationPayload = () => {
        $scope.organizationPayload = angular.copy(organizationTemplate)
    }
    $scope.resetOrganizationPayload()

    $scope.updateOrgTemplate = (org) => {
        $scope.organizationPayload = _.pick(org, ['id', 'backoffice_url', 'type'])
    }

    $scope.addOrganization = () => {
        const payload = _.pickBy($scope.organizationPayload)
        return DataAccessRefOrganization.addOrganization(payload).$promise
        .then(() => {
            AlertManager.success('Orgnisation créée')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }


    $scope.updateOrganization = function (organization, payload = {}) {
        const organizationPayload = _.assign({},
            _.omit(organization, [
                'service_order_recipients',
                'agreements',
                'agreementsTP',
                'expanded',
                'activeTabIndex',
                'service_order_conf',
                'agreementPayload',
                'defaultProviderOfferPayload',
            ]), payload)
        if (organization.defaultProviderOfferPayload && organization.defaultProviderOfferPayload.override != null) {
            organizationPayload.default_provider_offers = organization.defaultProviderOfferPayload.override ? _.omit(organization.defaultProviderOfferPayload, ['override']) : null
        }
        return DataAccessRefOrganization.updateOrganization({ id: organization.id }, organizationPayload).$promise.then(() => {
            AlertManager.success('Orgnisation modifiée')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }

    $scope.serviceOrderConfFields = {
        handle_service_orders: {
            hidden: () => !handlesB2GB2B,
            label: 'Activer la gestion ordres de service',
            required: true,
            type: 'checkbox',
        },
        service_order_recipients: {
            hidden: (template) => !template.handle_service_orders,
            required: true,
            label: 'Destinataire OS',
            type: 'emails',
        },
        signature: {
            hidden: (template) => !template.handle_service_orders,
            required: true,
            label: 'Label bloc signature',
            type: 'text',
        },
        signatureLocation: {
            hidden: (template) => !template.handle_service_orders,
            required: true,
            label: 'Localisation de la signature',
            type: 'text',
        },
        lotNumber: {
            hidden: (template) => !template.handle_service_orders,
            required: true,
            label: 'Numéro de lot',
            type: 'text',
        },
        idMarket: {
            hidden: (template) => !template.handle_service_orders,
            required: true,
            label: 'Numéro de marché',
            type: 'text',
        },
        providerName: {
            hidden: (template) => !template.handle_service_orders,
            required: true,
            label: 'Titulaire',
            type: 'text',
        },
        headerPhrase: {
            hidden: (template) => !template.handle_service_orders,
            required: true,
            label: 'Phrase du header',
            type: 'text',
        },
    }

    $scope.updateServiceOrderConfTemplate = (org) => {
        $scope.serviceOrderConfPayload = _.assign({}, _.pick(org, ['handle_service_orders']), org.service_order_conf)
    }

    $scope.updateServiceOrderConf = function (organization) {
        const organizationPayload = {
            handle_service_orders: $scope.serviceOrderConfPayload.handle_service_orders,
            service_order_conf: _.omit($scope.serviceOrderConfPayload, 'handle_service_orders'),
        }
        return DataAccessRefOrganization.updateOrganization({ id: organization.id }, organizationPayload).$promise.then(() => {
            AlertManager.success('Configuration des ordres de service modifiée')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }

    const backofficeMenusTemplate = {
        validation_perimeter_access: false,
        contracts_followup_access: false,
        elec_perimeter_management: false,
        optimization_turpe_access: false,
        end_agreement_vision: false,
    }

    $scope.backofficeMenusFields = {
        validation_perimeter_access: {
            label: 'Accès à la validation du périmètre',
            required: true,
            type: 'checkbox',
        },
        contracts_followup_access: {
            label: 'Accès au suivi des contrats',
            required: true,
            type: 'checkbox',
        },
        elec_perimeter_management: {
            label: 'Accès à la gestion de point (ajout, activation et résiliation)',
            required: true,
            type: 'checkbox',
        },
        optimization_turpe_access: {
            label: 'Accès à la validation des optimisations TURPE',
            required: true,
            type: 'checkbox',
        },
        end_agreement_vision: {
            label: 'Accès à la page de fin de marché',
            required: true,
            type: 'checkbox',
        },
    }

    $scope.updateBackofficeMenusTemplate = (org) => {
        $scope.backofficeMenusPayload = _.assign({}, backofficeMenusTemplate, org.backoffice_menus)
    }

    $scope.updateBackofficeMenusConf = function (organization) {
        const organizationPayload = {
            backoffice_menus: $scope.backofficeMenusPayload,
        }
        return DataAccessRefOrganization.updateOrganization({ id: organization.id }, organizationPayload).$promise.then(() => {
            AlertManager.success(`Configuration de l'accès aux menus mise à jour`)
            $scope.refresh()
        }).catch(ErrorCatcher)
    }

    $scope.contactInfosFields = {
        phone: {
            label: 'Téléphone',
            type: 'text',
        },
        email: {
            label: 'Email',
            type: 'text',
        },
        jiraName: {
            label: 'Nom',
            type: 'text',
        },
        zendeskId: {
            label: 'Id de brand zendesk',
            type: 'text',
        },
        hours: {
            label: 'Horaires',
            type: 'text',
        },
        emergencyPhone: {
            label: 'Contact',
            type: 'text',
        },
        iban: {
            label: 'IBAN',
            type: 'text',
        },
        bic: {
            label: 'BIC',
            type: 'text',
            pattern: CommonRegex.bic,
        },
        bank: {
            label: 'Banque',
            type: 'text',
        },
        perimeterValidationPeriodStartDate: {
            label: 'Début période de validation de périmètre',
            type: 'date',
            max: (template) => template.perimeterValidationPeriodEndDate,
        },
        perimeterValidationPeriodEndDate: {
            label: 'Fin période de validation de périmètre',
            type: 'date',
            min: (template) => template.perimeterValidationPeriodStartDate,
        },
    }

    $scope.updateContactInfosTemplate = (org) => {
        const rib = org.contact_infos.ribInfo || {}
        const { start_date: perimeterValidationPeriodStartDate, end_date: perimeterValidationPeriodEndDate } = _.get(org.contact_infos, 'perimeterValidationPeriod', {})
        $scope.contactInfosPayload = _.assign({}, org.contact_infos, rib, { perimeterValidationPeriodStartDate, perimeterValidationPeriodEndDate })
    }

    $scope.updateContactInfos = function (organization) {
        const { iban, bic, bank } = $scope.contactInfosPayload
        const organizationPayload = {
            contact_infos: $scope.contactInfosPayload,
        }
        if (iban || bic || bank) {
            const rebuiltRibInfo = { bic, iban, bank }
            organizationPayload.contact_infos.ribInfo = rebuiltRibInfo
            delete organizationPayload.contact_infos.iban
            delete organizationPayload.contact_infos.bic
            delete organizationPayload.contact_infos.bank
        }
        const perimeterValidationPeriod = {
            start_date: organizationPayload.contact_infos.perimeterValidationPeriodStartDate,
            end_date: organizationPayload.contact_infos.perimeterValidationPeriodEndDate,
        }
        delete organizationPayload.contact_infos.perimeterValidationPeriodStartDate
        delete organizationPayload.contact_infos.perimeterValidationPeriodEndDate
        if (perimeterValidationPeriod) {
            organizationPayload.contact_infos.perimeterValidationPeriod = perimeterValidationPeriod
        }
        return DataAccessRefOrganization.updateOrganization({ id: organization.id }, organizationPayload).$promise.then(() => {
            AlertManager.success(`Informations de contact mises à jour`)
            $scope.refresh()
        }).catch(ErrorCatcher)
    }

    $scope.expandOrganisation = (org) => {
        if (handlesB2GB2B && ['B2G', 'B2B'].includes(org.type)) {
            org.expanded = !org.expanded
            if (org.agreements.length) {
                org.agreementsTP = new NgTableParams({ count: 20 }, {
                    counts: [],
                    dataset: org.agreements,
                })
            }
        }
    }

    const agreementTemplate = {
        id: null,
        type: null,
        start_date: null,
        end_date: null,
        allowed_payment_modes: null,
        allowed_segments: null,
        bill_distributor_readings: $scope.handlesBillDistributorReadings ? null : false,
        generateFacturX: false,
        is_non_profiled: false,
    }

    $scope.agreementFields = {
        id: {
            label: 'Identifiant',
            required: true,
            type: 'text',
        },
        lot: {
            label: 'Numéro du lot',
            required: true,
            type: 'text',
        },
        type: {
            label: 'Type',
            required: true,
            type: 'radio',
            enum: [{ value: 'ELEC', label: 'Électricité' }, { value: 'GAS', label: 'Gas' }],
        },
        start_date: {
            label: 'Date de début',
            required: true,
            type: 'date',
            max: (template) => template.end_date,
        },
        end_date: {
            label: 'Date de fin',
            required: true,
            type: 'date',
            min: (template) => template.start_date,
        },
        allowed_payment_modes: {
            label: `Modes de paiement (séparés par ',')`,
            required: true,
            type: 'text',
        },
        allowed_segments: {
            label: `Segments permis (séparés par ',')`,
            required: true,
            type: 'text',
        },
        bill_distributor_readings: {
            label: `Facturation sur index distributeurs`,
            hidden: () => !$scope.handlesBillDistributorReadings,
            required: true,
            type: 'radio',
            enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
        },
        generateFacturX: {
            label: `Génération Factur-X`,
            hidden: () => !$scope.handlesFacturX,
            required: true,
            type: 'radio',
            enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
        },
        is_non_profiled: {
            label: `Calendrier déprofilé`,
            hidden: () => !$scope.handleIsNonProfiled,
            required: true,
            type: 'radio',
            enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
        },
        is_4_postes_active: {
            label: `Calend. F 4P`,
            required: true,
            type: 'radio',
            enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
        },
    }

    $scope.updateAgreementFields = angular.copy(_.omit($scope.agreementFields, canUpdateBillDistributorReadings ? [] : ['bill_distributor_readings']))
    $scope.updateAgreementFields.id.hidden = true

    $scope.resetAgreementPayload = (org) => {
        org.agreementPayload = org.agreementPayload || angular.copy(agreementTemplate)
    }

    $scope.updateAgreementTemplate = (agreement) => {
        $scope.agreementPayload = _.assign({}, _.omit(agreement, ['billing_configuration']), agreement.billing_configuration)
    }

    const BILLING_CONFIGURATION_FIELDS = ['generateFacturX', 'is_non_profiled', 'is_4_postes_active']

    const formatAgreementFields = (payload) => {
        const paymentModes = payload.allowed_payment_modes.replace(/ /g, '').toUpperCase().split(',')
        if (_.some(paymentModes, (pm) => !PAYMENT_MODES.includes(pm))) {
            AlertManager.error(`Les modes de paiement possibles sont [${PAYMENT_MODES.join(', ')}]`)
            return false
        }
        paymentModes.sort()
        payload.allowed_payment_modes = _.uniq(paymentModes).join(',')

        const segments = payload.allowed_segments.replace(/ /g, '').toUpperCase().split(',')
        if (_.some(segments, (seg) => !SEGMENTS[payload.type].includes(seg))) {
            AlertManager.error(`Les segments possibles pour les marchés "${payload.type}" sont [${SEGMENTS[payload.type].join(', ')}]`)
            return false
        }
        segments.sort()
        payload.allowed_segments = _.uniq(segments).join(',')
        payload.billing_configuration = _.pick(payload, BILLING_CONFIGURATION_FIELDS)
        _.each(BILLING_CONFIGURATION_FIELDS, (field) => delete payload[field])
        return true
    }

    $scope.addAgreement = (org) => {
        org.agreementPayload.organization = org.id
        if (!formatAgreementFields(org.agreementPayload)) {
            return
        }
        return DataAccess.addAgreement(org.agreementPayload).$promise
        .then(() => {
            AlertManager.success('Marché créé')
            delete org.agreementPayload
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }

    $scope.updateAgreement = function (agreement) {
        const agreementPayload = angular.copy($scope.agreementPayload)
        delete agreementPayload.id
        if (!formatAgreementFields(agreementPayload)) {
            return
        }
        agreement.updating = true
        return DataAccess.updateAgreement({ id: $scope.agreementPayload.id }, _.omit(agreementPayload, ['updating'])).$promise.then(() => {
            AlertManager.success('Marché modifié')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            agreement.updating = false
        })
    }

    // org defaultProviderOffer
    $scope.defaultProviderOfferFields = {
        'override': {
            label: 'Surcharger les offres par défaut ?',
            type: 'checkbox',
        },
        'part': {
            hidden: (t) => !t.override,
            label: 'Offre particuliers (laisser vide si pas de surcharge)',
            size: 35,
            type: 'typeahead',
            enum: $scope.offers,
        },
        'small-business': {
            hidden: (t) => !t.override,
            label: 'Offre professionnels (laisser vide si pas de surcharge)',
            size: 35,
            type: 'typeahead',
            enum: $scope.offers,
        },
    }

    DataAccessOffers.getOffers().$promise.then((offers) => {
        const offersFiltered = _.orderBy(_.compact(_.map(_.filter(offers, (o) => o.segments.includes('C5')), (m) => ({ value: m.id, label: m.label }))), 'value')
        $scope.defaultProviderOfferFields.part.enum = offersFiltered
        $scope.defaultProviderOfferFields['small-business'].enum = offersFiltered
    })

    $scope.resetDefaultProviderOfferPayload = (org) => {
        org.defaultProviderOfferPayload = org.default_provider_offers || {}
        org.defaultProviderOfferPayload.override = !!org.defaultProviderOfferPayload && Object.keys(org.defaultProviderOfferPayload).length > 0
    }

    // consents
    $scope.consentPayload = { index: false, curves: false }

    $scope.consentFields = {
        index: {
            label: 'Transmission des index',
            required: true,
            type: 'radio',
            enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
        },
        curves: {
            label: 'Collecte et transmission des courbes de charge',
            required: true,
            type: 'radio',
            enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
        },
    }

    $scope.updateConsentsTemplate = (agreement) => {
        $scope.consentPayload = _.clone(agreement.consents || { index: false, curves: false })
    }

    $scope.updateConsents = (agreement) => {
        agreement.updating = true
        return DataAccess.updateAgreementConsents({ id: agreement.id }, $scope.consentPayload).$promise.then((result) => {
            const consentNb = result.contracts && result.contracts.length
            const contractNb = result.contracts && _.uniqBy(result.contracts, 'id_contract').length
            AlertManager.success(`Consentements modifiés${consentNb ? `, ${consentNb} consentements mis à jour sur ${contractNb} contrats.` : '.'}`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            agreement.updating = false
        })
    }


    $scope.closeAgreementFields = {
        label: {
            label: `<span class="red"><span class="fa fa-warning"></span> La clôture du marché consiste à changer le rôle`
                + ` de tous les membres utilisateurs affectés seulement à des paquets facturiers appartenant à ce marché.</span>`,
            type: 'label',
        },
    }

    $scope.closeAgreement = (agreement) => {
        agreement.closing = true
        return DataAccess.closeAgreement({ id: agreement.id }, {}).$promise
        .then((result) => {
            AlertManager.success(result.message)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            agreement.closing = false
        })
    }

    $scope.openDefaultProviderOfferModal = (agreement) =>
        ModalService.openModal({ type: 'defaultProviderOfferModal', size: 'md' },
            { energy_type: agreement.type, default_provider_offers: agreement.default_provider_offers, displayOverride: false },
            (default_provider_offers) => {
                agreement.updating = true
                return DataAccess.updateAgreement({ id: agreement.id }, { default_provider_offers }).$promise.then(() => {
                    AlertManager.success('Offres par défaut du marché modifiées')
                    $scope.refresh()
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    agreement.updating = false
                })
            })
})
